// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export const APINotSupportedForRDLError = "This API is currently not supported for RDL reports";
export const EmbedUrlNotSupported = "Embed URL is invalid for this scenario. Please use Power BI REST APIs to get the valid URL";

